import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    Box,
    Chip
} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import styled from 'styled-components';

const ListaDepartamentos = ({ departamentos, documentosDepartamentos, empresaId = null, todosLosDocumentos = [] }) => {
    const navigate = useNavigate();

    let departamentosFiltrados = departamentos;

    if (empresaId) {
        departamentosFiltrados = departamentos.filter(dep => {
            const docsDelDep = todosLosDocumentos.filter(doc =>
                doc.permisos && doc.permisos.some(permiso =>
                    permiso.tipo_id === 'departamento' &&
                    permiso.permitido_id === dep.Id &&
                    permiso.empresa_id === parseInt(empresaId)
                )
            );
            return docsDelDep.length > 0;
        });
    }

    const handleClickDepartamento = (departamentoId) => {
        const params = new URLSearchParams();
        params.set('tipo', 'departamento');
        params.set('id', departamentoId);
        if (empresaId) {
            params.set('empresaId', empresaId);
        }
        navigate(`?${params.toString()}`);
    };

    return (
        <Box sx={{ padding: '20px 0' }}>
            <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mb: 3 }}>
                Selecciona un Departamento
            </Typography>
            {departamentosFiltrados.length === 0 ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="200px"
                    bgcolor="#f5f5f5"
                    borderRadius={2}
                >
                    <Typography variant="h6" color="textSecondary">
                        No hay departamentos disponibles
                    </Typography>
                </Box>
            ) : (
                <Grid container spacing={3}>
                    {departamentosFiltrados.map((departamento) => (
                        <Grid item xs={12} sm={6} md={4} key={departamento.Id}>
                            <CardDepartamento
                                elevation={2}
                                onClick={() => handleClickDepartamento(departamento.Id)}
                            >
                                <CardContent sx={{ textAlign: 'center', padding: '30px 20px !important' }}>
                                    <IconoDepartamento>
                                        <GroupsIcon />
                                    </IconoDepartamento>
                                    {departamento.Negocios && departamento.Negocios.length > 0 && (
                                        <Chip
                                            label={departamento.Negocios[0].nombre}
                                            size="small"
                                            sx={{
                                                mb: 1,
                                                backgroundColor: 'rgba(0, 60, 102, 0.1)',
                                                color: '#003c66',
                                                fontWeight: 600,
                                                fontSize: '11px'
                                            }}
                                        />
                                    )}
                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        gutterBottom
                                        sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            minHeight: '50px'
                                        }}
                                    >
                                        {departamento.nombre}
                                    </Typography>
                                    <ContadorDocs>
                                        {documentosDepartamentos[departamento.Id] || 0}
                                    </ContadorDocs>
                                    <Typography variant="body2" color="textSecondary">
                                        Documentos
                                    </Typography>
                                </CardContent>
                            </CardDepartamento>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

const CardDepartamento = styled(Card)`
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 15px !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
    height: 100%;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 24px rgba(0, 60, 102, 0.2) !important;
    }
`;

const IconoDepartamento = styled.div`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #336385;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 15px;
    box-shadow: 0 4px 12px rgba(0, 60, 102, 0.3);

    svg {
        font-size: 35px;
        color: white;
    }
`;

const ContadorDocs = styled.div`
    font-size: 36px;
    font-weight: 800;
    background: #336385;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 10px 0;
`;

export default ListaDepartamentos;
